import { useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from "react-i18next";

import SectionTitle from "../Shared/SectionTitle/SecctionTitle";
import classes from './Gallery.module.css';

import screen1 from '../../assets/images/screen_1.jpg';
import screen2 from '../../assets/images/screen_2.jpg';
import screen3 from '../../assets/images/screen_3.jpg';
import screen4 from '../../assets/images/screen_4.jpg';
import screen5 from '../../assets/images/screen_5.jpg';
import screen6 from '../../assets/images/screen_6.jpg';
import screen7 from '../../assets/images/screen_7.jpg';
import screen8 from '../../assets/images/screen_8.jpg';

const Gallery = (props) => {
    const { t } = useTranslation();
    const [width, setWidth] = useState(window.innerWidth);

    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 480;


    let settings = {
        dots: true,
        className: "center",
        centerMode: true,
        infinite: true,
        centerPadding: "60px",
        slidesToShow: 3,
        speed: 500,
        arrows: true,
        responsive: [
            {
                breakpoint: 1024, // tablet / small laptop
                settings: {
                    slidesToShow: 3,
                    centerPadding: "40px",
                }
            },
            {
                breakpoint: 768, // tablet
                settings: {
                    slidesToShow: 1,
                    centerPadding: "80px",
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: false,
                    centerMode: true,
                    centerPadding: '40px',
                    slidesToShow: 1
                }
            }
        ]

    };
    if (isMobile) {
        settings.slidesToShow = 1;
        settings.arrows = false;
    }

    return (
        <section id="gallery">
            <div className="container">
                <SectionTitle subtitle={t('gallery.subtitle')} title={t('gallery.title')} />
                <div className={classes.ScreenshotSlider}>
                    <Slider {...settings}>
                        <div className={classes.GalleryItem}>
                            <img src={screen1} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen2} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen3} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen4} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen5} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen6} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen7} alt="Red Taxi" />
                        </div>
                        <div className={classes.GalleryItem}>
                            <img src={screen8} alt="Red Taxi" />
                        </div>
                    </Slider>
                </div>
            </div>
        </section>
    );
}

export default Gallery;